import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEN from './locales/en-US/translation.json';
import translationPT from './locales/pt-PT/translation.json';

const resources = {
  'en-US': {
    translation: translationEN,
  },
  'pt-PT': {
    translation: translationPT,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en-US',
    detection: {
      order: ['querystring'],
      lookupQuerystring: 'locale',
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
